import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { ArticleContent, RegisterPageCmsResource } from '@cardihab/content-cache';
import { ContentService } from 'src/app/services/content.service';
import { CLINICIAN } from 'src/app/utils/constants';

@Component({
  selector: 'information-modal',
  templateUrl: 'information-modal.html',
  styleUrls: ['./information-modal.scss'],
})
export class InformationModalPage {
  title = 'Register';
  clinician: string = CLINICIAN;
  contents: ArticleContent[] | undefined;
  constructor(
    private docTitle: Title,
    private modalController: ModalController,
    private contentService: ContentService,
  ) {
    this.contentService.watchContent(
      RegisterPageCmsResource,
    ).subscribe(registerInformation => {
      if (registerInformation?.length) {
        const register = registerInformation[0];
        this.contents = (register as RegisterPageCmsResource)?.information
      }
    });
    this.docTitle.setTitle(this.title);
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
